import { ChangeDetectorRef, Component, Inject, Input, signal, Signal } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { CommonService } from 'src/app/services/common.service';
import { SnackbarService } from 'src/app/shared/snackbar/snackbar.service';

@Component({
  selector: 'app-cancel-modal',
  imports: [TranslateModule],
  templateUrl: './cancel-modal.component.html',
  styleUrl: './cancel-modal.component.scss',
  standalone: true
})
export class CancelModalComponent {
  shiftId: number
  isUserBlock = signal(false)

  constructor(private dialogRef: MatDialogRef<CancelModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private commonService: CommonService,
    private snackbarService: SnackbarService,
    private translate: TranslateService,
     private cdr: ChangeDetectorRef
  ) {

    this.shiftId = data.shiftId
    this.isUserBlock.set(this.data.isBlockUSer)
  }

  cancelShift() {
    this.dialogRef.close();
  }

  deleteShift() {
  this.commonService.deleteShift(this.shiftId).subscribe({
    next: (data) => {
      this.snackbarService.showSuccess(this.translate.instant('guard-shift-details.cancel.cancel-shift-sucess'));
      setTimeout(() => {
        this.dialogRef.close({ success: true });
        this.cdr.detectChanges(); 
      }, 0);
    },
    error: (err) => {
      this.snackbarService.showError(this.translate.instant('guard-shift-details.cancel.cancel-shift-errror'));
      this.dialogRef.close({ success: false });
      this.cdr.detectChanges(); 
    }
  });
}

  // Function for block user
  blockUser() {
    this.commonService.blockedUser(this.shiftId, this.data.id).subscribe({
      next: (data) => {
        this.snackbarService.showSuccess(this.translate.instant('guard-shift-details.block.block-guard-sucess'));
        this.dialogRef.close({ success: true });
      },
      error: (err) => {
        this.snackbarService.showError(this.translate.instant('guard-shift-details.block.block-guard-error'));
        this.dialogRef.close({ success: false });
      }
    });
  }

  onBackdropClick(): void {
    this.dialogRef.close(); 
  }

}
